<template>
  <div class="about">
    <div>
      <h2 class="hover-underline-animation">
        Registrace
      </h2>
    </div>
    <div class="card">
      <div>
        <h3>Jméno</h3>
      </div>
      <div>
        <v-text-field
          v-model="name"
          placeholder="Jméno"
          outlined
          dense
          background-color="white"
        />
      </div>
      <div>
        <h3>Příjmení</h3>
      </div>
      <div>
        <v-text-field
          v-model="surname"
          placeholder="Příjmení"
          outlined
          dense
          background-color="white"
        />
      </div>
      <div>
        <h3>Přezdívka</h3>
      </div>
      <div>
        <v-text-field
          v-model="nickname"
          placeholder="Přezdívka (jestli nemáš tak nevyplňuj)"
          outlined
          dense
          background-color="white"
        />
      </div>
      <div>
        <h3>Email</h3>
      </div>
      <div>
        <v-text-field
          v-model="email"
          placeholder="Email"
          outlined
          dense
          background-color="white"
        />
      </div>
      <hr style="border:solid #f9d71c;">
      <div style="margin-top:20px; ">
        <div>
          <h3>Na co se chcete přihlásit</h3>
        </div>
        <div style="display:flex; justify-content: space-around; margin-top:30px;">
          <div>7 TO SMOKE <b>(15-)</b></div>
          <div>2v2 BATTLE <b>(15+)</b></div>
          <div>WORKSHOP</div>
        </div>
        <div style="display:flex; justify-content: space-around;">
          <v-checkbox
            dark
            color="#f9d71c"
            :disabled="doubles === 'Ano'"
            @click="check('seven')"
          />
          <v-checkbox
            dark
            color="#f9d71c"
            :disabled="seven === 'Ano'"
            @click="check('doubles')"
          />
          <v-checkbox

            dark
            color="#f9d71c"
            :disabled="workshopCount > 40"
            @click="check('workshop')"
          />
        </div>
      </div>
      <hr style="border:solid #f9d71c;">

      <div style="margin-top:30px;">
        <v-btn
          style="width:100%; background-color: #f9d71c; "
          @click="out = true"
        >
          <b>Registrovat se</b>
        </v-btn>
      </div>
    </div>
    <v-dialog
      v-model="out"
      dark
      max-width="500px"
    >
      <v-card style="text-align:center; background: hsl(0, 100%, 66%)">
        <v-card-title style="color:white; ">
          <b>Konec registrací</b>
        </v-card-title>
        <v-card-text>
          <div style="font-size:25px;color:white;">
            <b>Omlouváme se, ale dnes už se nemůžete registrovat na Groove Fusion Battle.</b>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      dark
      max-width="500px"
    >
      <v-card style="text-align:center">
        <v-card-title style="color:#f9d71c; ">
          Úspěšná registrace
        </v-card-title>
        <v-card-text>
          <div style="font-size:25px;color:#f9d71c;">
            Děkujeme za vaší registraci!
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="wrong"
      dark
      max-width="500px"
    >
      <v-card style="text-align:center">
        <v-card-title style="color:red; ">
          Špatná registrace
        </v-card-title>
        <v-card-text>
          <div style="font-size:25px;color:red;">
            <strong>Nevyplnil jste všechna povinná pole!</strong>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import db from '@/fb'
export default {
  data () {
    return {
      name: '',
      surname: '',
      nickname: '',
      email: '',
      seven: 'Ne',
      doubles: 'Ne',
      workshop: 'Ne',
      dialog: false,
      workshopCount: 0,
      out: false,
      wrong: false
    }
  },
  created () {
    db.collection('workshop').get().then(res => {
      res.docs.map(doc => (
        this.workshopCount = doc.data().num
      ))
    })
  },
  methods: {
    check (event) {
      if (event === 'seven') {
        if (this.seven === 'Ne') {
          this.seven = 'Ano'
        } else if (this.seven === 'Ano') {
          this.seven = 'Ne'
        }
      } else if (event === 'doubles') {
        if (this.doubles === 'Ne') {
          this.doubles = 'Ano'
        } else if (this.doubles === 'Ano') {
          this.doubles = 'Ne'
        }
      } else if (event === 'workshop') {
        if (this.workshop === 'Ne') {
          this.workshop = 'Ano'
        } else if (this.workshop === 'Ano') {
          this.workshop = 'Ne'
        }
      }
    },
    registerOut () {
      this.out = true
    },
    register () {
      if ((this.name !== '' && this.surname !== '' && this.email !== '') && (this.workshop === 'Ano' || this.doubles === 'Ano' || this.seven === 'Ano')) {
        const battleDancer = {
          firstName: this.name,
          surname: this.surname,
          nickname: this.nickname,
          email: this.email,
          checkSeven: this.seven,
          check2v2: this.doubles,
          checkWorkshop: this.workshop
        }
        console.table(battleDancer)
        db.collection('dancers').add(battleDancer)
        if (this.workshop === 'Ano') {
          const plus = this.workshopCount + 1
          db.collection('workshop')
            .doc('count')
            .update({ num: plus }).then(this.workshopCount = this.workshopCount + 1)
        }
        this.name = ''
        this.surname = ''
        this.email = ''
        this.nickname = ''
        this.seven = 'Ne'
        this.doubles = 'Ne'
        this.workshop = 'Ne'
        this.dialog = true
        setTimeout(() => { this.$router.push('/') }, 3000)
      } else {
        this.wrong = true
        setTimeout(() => { this.wrong = false }, 3000)
      }
    }

  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Six+Caps&display=swap');
html, body{
  height: 100vh;
}
.v-main__wrap{
    background-color: rgb(0, 0, 0);
}
.about{
    padding-inline: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    color: #f9d71c;
    background-color: black;
    margin-bottom: 50px;
}
h2 {
  display: inline-block;
  position: relative;
color: #f9d71c;
font-family: 'Six Caps', sans-serif;
font-size: 100px;
 letter-spacing: 1px;

 margin-bottom: 30px;
}

h2:after {
  content: '';
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 12px;
  bottom: 0;
  left: 0;
  background-color: #fd48fe;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}

h2:hover:after {
  transform: scaleX(1);
  transform-origin: bottom left;
}
.about h3{
    font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
    font-size: 25px;
    text-align: start;
    padding-block: 5px;
}
.about .card{
    padding: 30px;
    width: 100%;
    max-width: 700px;
    border: solid 4px #f9d71c;
    border-radius: 10px;
}
.letters{
     font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
}
</style>